import angular from 'angular';
import RemarkComponent from './remark.component';
export default angular.module('invision.customercare.remark', []).component('remark', RemarkComponent).name;